import { Global } from 'src/app/Service/global.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RechercheService {

  constructor(private http:HttpClient, private global:Global) { }

  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  cssOptions = {
    headers: new HttpHeaders({
      "accept": "text/css;charset=utf-8",
      "content-type": "text/css;charset=utf-8"
    })
  };

  
  get(url):Observable<string>{
    return this.http.get(url,{responseType: 'text'});
  }
  getParamRecherche(){
    return this.http.get(this.global._basedUrl + "/_api/web/lists/GetByTitle('RechercheParametres')/items?"
    +"$select=*",this.httpOptions);
  }
  getRechercheContenu(){
    return this.http.get(this.global._basedUrl +"/_api/web/lists/GetByTitle('RechercheContenu')/items?"
    +"$select=*",this.httpOptions);
  }
  getFieldList(url, listName) {
   // console.log(url +"/_api/web/lists/GetByTitle('"+ listName+"')/fields")
    return this.http.get(url +"/_api/web/lists/GetByTitle('"+ listName+"')/fields"
    ,this.httpOptions);
  }
  searchBibliotheque(url, key) {
    //console.log(this.global._basedUrl  +"/_api/search/query?querytext='(Path:\"" + url+ "\") AND (\"" + key + "\") AND (contentTypeId:\"0x0101*\" AND (FileExtension:\"doc\" OR FileExtension:\"docx\"  OR FileExtension:\"html\" OR FileExtension:\"ppt\" OR FileExtension:\"pptx\" OR FileExtension:\"xls\" OR FileExtension:\"xlsx\" OR FileExtension:\"xlsm\" OR FileExtension:\"pdf\" OR FileExtension:\"txt\"))'&sortlist= 'created:descending '&RowLimit=7 &selectProperties='Title,Author,OriginalPath,created,FileExtension,ServerRedirectedURL,ListItemID'")
    return this.http.get(this.global._basedUrl  +"/_api/search/query?querytext='(Path:\"" + url+ "\") AND (\"" + key + "\") AND (contentTypeId:\"0x0101*\" AND (FileExtension:\"doc\" OR FileExtension:\"docx\"  OR FileExtension:\"html\" OR FileExtension:\"ppt\" OR FileExtension:\"pptx\" OR FileExtension:\"xls\" OR FileExtension:\"xlsx\" OR FileExtension:\"xlsm\" OR FileExtension:\"pdf\" OR FileExtension:\"txt\"))'&sortlist= 'created:descending'&RowLimit=500&selectProperties='Title,Author,OriginalPath,created,FileExtension,ServerRedirectedURL,ListItemID'&QueryTemplatePropertiesUrl='spfile://webroot/queryparametertemplate.xml'"
    ,this.httpOptions);
  }
  searchLists(url, select, filter, list){
    return this.http.get(url +"/_api/web/lists/GetByTitle('"+ list+"')/items?$select=" + select +  "&$filter=" +filter
    ,this.httpOptions); 
  }
  getPageStatiqueById(url,Id) {
    return this.http.get(url+"/_api/web/lists/GetByTitle('Pages')/items?"
    +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter=Id eq " + Id,this.httpOptions);
  
  }
  getServicePortPageId(url, ListName,Id) {
    return this.http.get(url+"/_api/web/lists/GetByTitle('"+  ListName+ "')/items?"
    +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$filter=Id eq " + Id,this.httpOptions);
  
  }

}